import { JobTemplate } from '../job.templates/job.template';
import { OpportunityStage } from './opportunity.stage';
import { JobCreateRequest } from '../../requests/job/job.create.request';
import { Entity } from '../entity';

export type PartialJobCreateRequest = Pick<
    JobCreateRequest,
    'site' | 'owner' | 'priceBook' | 'customer' | 'workOrders' |
    'address' | 'description' | 'placeId' | 'contact' | 'type' | 'customJobNumber'
>;

export interface OpportunityConvertRequest {
    _id: string;
    convertType: OpportunityConvertType;
    templateStage?: Entity;
    template?: JobTemplate;
    createRequest?: PartialJobCreateRequest;
    stage: OpportunityStage;
    probability: number,
    copyActivities: boolean;
}

export enum OpportunityConvertType {
    JobTemplate = 'Job Template',
    ItemCategories = 'Item categories',
    QuoteSections = 'Quote sections',
    SingleStage = 'Single stage',
}